<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <CInput v-model="form.address1"  label="Address"   />
          </CCol> 
          </CRow>
       
         <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'editaddress'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
        
        </template>
    </CModal>
  </form>
</template>
<script>
import EventBus from '@/eventBus';

import member from '@/services/member';

import moment from 'moment'

export default {
name: 'covenantmodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      uuid:'',
      firstname:'',
      lastname:'',
      dob:'',
      email:'',
      address1:''
    },
    }
  },

  mounted (){
     
   },
  
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_ADDRESS', (params) => {
      if(params.data){
      member.getMemberbyID(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = params.data;
      self.form.firstname = res.data.firstname;
      self.form.lastname = res.data.lastname;
      self.form.dob = res.data.dob;
      self.form.email = res.data.email;
      self.form.address1 = res.data.address1;
      
       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = "";
      self.form.firstname = "";
      self.form.lastname = "";
      self.form.dob = "";
      self.form.email = "";
      self.form.address1 = "";
      
      }
 
    });
    this.form.uuid = this.$route.query.Pud
    
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
   update(id){
      this.show = false;
      if( this.form.dob != null ){this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')}
     
      member.updateMember(id,this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        this.showModal= false
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },  
  
   
  }
}
</script>

<style>

</style>